import { s } from '@/theme/tokens/spacing';
import { typeScale } from '@/theme/tokens/typography';

export const deltaIndicatorSx = {
  fontSize: typeScale.xs,
  marginLeft: s('sm'),
} as const;
